<div id="forms" class="page-layout simple fullwidth" fxLayout="column">
  <!-- TOP BACKGROUND -->
  <div class="top-bg accent"></div>
  <!-- / TOP BACKGROUND -->

  <!-- CENTER -->
  <div class="center" fxFlex="100">

    <!-- CONTENT CARD -->
    <div class="content-card" [ngClass]="">



      <!-- CONTENT -->
      <div class="content p-24">
        <div class="mb-24"  fxLayoutAlign="start stretch" fxLayout.gt-md="row" fxFlex="100">

          <!-- REACTIVE FORM EXAMPLE -->


          <!--cuadro  1 -->
          <div class="mat-card mat-elevation-z4 p-24 mr-24" fxLayout="row" fxLayoutAlign="start stretch" fxFlex="50">
          <div class="mat-card mat-elevation-z4 p-24 mr-24" fxLayout="column" fxLayoutAlign="start stretch" fxFlex="100">

            <div class="h2 mb-24">{{'FOCUS.CREAR.DATO' | translate}}</div>

            <div fxLayout="row" fxLayoutAlign="start center">

              <mat-form-field appearance="outline" fxFlex="100">
                <mat-label>{{'FOCUS.CREAR.NAME' | translate}}</mat-label>

                <input *ngIf="infoGrupo" matInput placeholder="{{'FOCUS.CREAR.NAME' | translate}}" (blur)="CrearGrupoFocus($event, 1)"
                [(ngModel)]="infoGrupo.data.nombre">

                <input *ngIf="!infoGrupo" matInput placeholder="{{'FOCUS.CREAR.NAME' | translate}}" (blur)="CrearGrupoFocus($event, 1)"
                >
              </mat-form-field>



            </div>
            <div fxLayout="row" fxLayoutAlign="start center" >
              <mat-form-field appearance="outline" fxFlex="100">
                <mat-label>{{'FOCUS.CREAR.DESCRIPCION' | translate}}</mat-label>

                <textarea *ngIf="infoGrupo" matInput placeholder="{{'FOCUS.CREAR.DESCRIPCION' | translate}}" (blur)="CrearGrupoFocus($event, 2)"
                [(ngModel)]="infoGrupo.data.descripcion"></textarea>

                <textarea *ngIf="!infoGrupo"  matInput placeholder="{{'FOCUS.CREAR.DESCRIPCION' | translate}}" (blur)="CrearGrupoFocus($event, 2)"
                ></textarea>
              </mat-form-field>
            </div>
            <div fxLayout="row" fxLayoutAlign="start center">

              <mat-form-field appearance="outline" fxFlex="100" class="pr-4">
                <mat-label>{{'FOCUS.CREAR.FILTROS' | translate}}</mat-label>
                <mat-select  multiple>
                  <mat-option  *ngFor="let filtro of filtrosFocusArea" [value]="filtro.nombre" (click)="MostrarPais(filtro.id);" >{{filtro.nombre}}</mat-option>
                </mat-select>
                <mat-error></mat-error>
              </mat-form-field>
            </div>
          </div>
          </div>
          <!-- / REACTIVE FORM EXAMPLE -->
          <!--cuadro  2 -->
          <div class="mat-card mat-elevation-z4 p-24 mr-24" fxLayout="row" fxLayoutAlign="start stretch" fxFlex="100">
          <div class="mat-card form-errors-model p-24 mat-elevation-z4"  fxLayout="column" fxLayoutAlign="start stretch">
            <div class="h2 mb-24">{{'FOCUS.CREAR.FILSELEC' | translate}}</div>

            <div>

              <ng-container >
                <div >

                  <!--selector  de Antiguedad -->
                  <mat-expansion-panel class="mb-20" *ngFor="let filtro of filtrosFocusArea">
                    <mat-expansion-panel-header class="accent-100" *ngIf="arregloBoolean[filtro.id]">
                      <!-- <mat-panel-description>
                      {{'FOCUS.CREAR.GENDER' | translate}}
                    </mat-panel-description> -->
                    <mat-panel-description >
                      {{filtro.nombre}}
                    </mat-panel-description>
                  </mat-expansion-panel-header>
                  <br>
                  <div fxLayout="row" fxLayoutAlign="center" >
                    <div  class="example-list" >
                      <div class="example-box" cdkDrag *ngFor="let subfiltro of filtro.subfiltros" >
                        <mat-icon aria-hidden="false" class="mr-20" matTooltip="" cdkDragHandle>menu</mat-icon>
                        <div class="example-custom-placeholder" *cdkDragPlaceholder></div>
                        <div appearance="outline" fxFlex="50" class="pr-4" fxLayoutAlign="start center">
                          <mat-checkbox   >
                            {{subfiltro}}
                          </mat-checkbox>


                        </div>

                      </div>
                    </div>
                  </div>

                  <div>

                  </div>

                </mat-expansion-panel>
              </div>

            </ng-container>


          </div>
          <!-- <div appearance="outline" fxFlex="50" class="pr-4" fxLayoutAlign="end center">
          <button mat-raised-button color="accent" style="width: 20%;">Guardar</button>
          </div> -->
          </div>
          </div>


    </div>


  </div>
  <!-- / CONTENT -->

</div>
</div>
</div>
